'use client';

import {
  datadogLogs,
  Site,
} from '@datadog/browser-logs';
import {
  appVersion,
  datadogClientToken,
  environment,
  isDatadogEnabled,
} from '@/env';

let ddInitialized = false;

export const enabledLogs = isDatadogEnabled && ['qa', 'prod'].includes((environment ?? '').toLowerCase());
export function initDatadogLogs() {
  try {
    if (!ddInitialized && enabledLogs) {
      datadogLogs.init({
        clientToken: datadogClientToken,
        site: ('us3.datadoghq.com') as Site,
        service: 'patient-portal-app',
        forwardConsoleLogs: ['error', 'warn'],
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        env: environment,
        version: appVersion,
      });
      ddInitialized = true;
    }
    // for debugging Application Version
    console.log('Application Version: ', appVersion);
  } catch {
    // No-op: do not block app if Datadog init fails
  }
}

// Eager init on import in client
if (typeof window !== 'undefined') {
  initDatadogLogs();
}
